module.exports = __webpack_public_path__ + "img/web.d7d389fa.png";